import { PhotoSection } from '@src/types/images';

/**
 * Remaps certain photo sections to the "Otros" (OTHERS) section for display.
 * For Panama (PAN) inspections, both the police ticket (POLICE_TICKET = 126) and
 * the signed legal power (LEGAL_POWER = 127) are shown under OTHERS (6).
 * Any other section, or any country other than PAN, is returned unchanged.
 */
export const remapSection = (
  sectionId: number,
  countryCode: string | null,
): number => {
  if (
    countryCode === 'PAN' &&
    (sectionId === PhotoSection.POLICE_TICKET ||
      sectionId === PhotoSection.LEGAL_POWER)
  ) {
    return PhotoSection.OTHERS;
  }
  return sectionId;
};
